class PaginationTheme extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.section;
    this.blogGrid = document.querySelector(`#blogGrid[data-id="${this.sectionId}"]`);
    this.loadMoreButton = this.querySelector('.load-more-button');
    this.loadMoreContainer = this.querySelector('.load-more-container');
    this.loadingOverlay = this.blogGrid?.querySelector('.loading-overlay');
    
    this.currentPage = 1;
    this.isLoading = false;
    
    this.init();
  }

  init() {
    if (!this.loadMoreButton || !this.blogGrid) return;
    
    this.loadMoreButton.addEventListener('click', this.handleLoadMore.bind(this));
  }

  async handleLoadMore() {
    if (this.isLoading) return;
    
    this.isLoading = true;
    this.showLoading();
    
    try {
      const nextPage = this.currentPage + 1;
      const response = await this.fetchNextPage(nextPage);
      
      if (response.ok) {
        const html = await response.text();
        this.processResponse(html);
        this.currentPage = nextPage;
      } else {
        console.error('Failed to load more articles');
        this.showError();
      }
    } catch (error) {
      console.error('Error loading more articles:', error);
      this.showError();
    } finally {
      this.isLoading = false;
      this.hideLoading();
    }
  }

  async fetchNextPage(page) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('page', page);
    
    return fetch(currentUrl.href, {
      method: 'GET',
      headers: {
        'Accept': 'text/html',
      }
    });
  }

  processResponse(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Find the blog grid in the response
    const newBlogGrid = doc.querySelector(`#blogGrid[data-id="${this.sectionId}"]`);
    if (!newBlogGrid) return;
    
    // Extract new blog post cards
    const newCards = newBlogGrid.querySelectorAll('.blog-post-card');
    
    // Add new cards to existing grid (before loading overlay)
    const loadingOverlay = this.blogGrid.querySelector('.loading-overlay');
    newCards.forEach(card => {
      this.blogGrid.insertBefore(card.cloneNode(true), loadingOverlay);
    });
    
    // Check if there's a next page
    const newPagination = doc.querySelector(`pagination-theme[data-section="${this.sectionId}"]`);
    if (!newPagination || !newPagination.querySelector('.load-more-button')) {
      this.hideLoadMoreButton();
    }
  }

  showLoading() {
    this.loadMoreContainer?.classList.add('is-loading');
    if (this.loadingOverlay) {
      this.loadingOverlay.style.display = 'flex';
    }
  }

  hideLoading() {
    this.loadMoreContainer?.classList.remove('is-loading');
    if (this.loadingOverlay) {
      this.loadingOverlay.style.display = 'none';
    }
  }

  hideLoadMoreButton() {
    if (this.parentElement) {
      this.style.display = 'none';
    }
  }

  showError() {
    const errorMessage = document.createElement('p');
    errorMessage.textContent = 'Failed to load more articles. Please try again.';
    errorMessage.style.color = '#d32f2f';
    errorMessage.style.textAlign = 'center';
    errorMessage.style.marginTop = '20px';
    
    this.loadMoreContainer?.appendChild(errorMessage);
    
    setTimeout(() => {
      errorMessage.remove();
    }, 5000);
  }
}

// Register the custom element
customElements.define('pagination-theme', PaginationTheme);

// Fallback for browsers that don't support custom elements
if (!window.customElements) {
  document.addEventListener('DOMContentLoaded', function() {
    const paginationElements = document.querySelectorAll('pagination-theme');
    paginationElements.forEach(element => {
      new PaginationTheme.call(element);
    });
  });
}